<template>
  <b-row>
    <b-col cols="12">
      <search-view :click-search="getDocumentTypes"/>
    </b-col>


    <b-col cols="12">
      <b-card title="">
        <b-overlay
            variant="white"
            :show="showLoading"
            spinner-variant="primary"
            blur="0"
            opacity=".75"
            rounded="sm"
        >
          <div class="ml-1 mb-2">
            <b-row>
              <b-col cols="12" md="9"
                     class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <label>Mostrar</label>
                <v-select
                    v-model="pageLength"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="['3','5','10','20']"
                    :clearable="false"
                    class="per-page-selector d-inline-block mx-50"
                    @input="changeLength"
                />
                <b-button variant="primary ml-1" @click="goToCreate()">
                  Añadir nuevo tipo de documento
                </b-button>
                <div class="ml-2">
                  <button class="btn btn-outline-success" @click="exportToExcel">Exportar a Excel</button>
                </div>
              </b-col>
            </b-row>
          </div>

          <b-table
              ref="refUserListTable"
              class="position-relative"
              :items="document_types"
              responsive
              striped
              sticky-header
              :fields="columns"
              primary-key="id"
              show-empty
              empty-text="No hay registros"
          >
            <template #cell(name)="data" >
              {{ data.item.name }}
            </template>

            <template #cell(actions)="data" class="col-sm-2">
              <router-link :to="{ name: 'auxiliar_documentTypes_edit_gei', params: { id: data.item.id} }">
                <feather-icon
                    :id="`invoice-row-${data.item.id}-send-icon`"
                    icon="EditIcon"
                    class="cursor-pointer"
                    size="16"
                />

              </router-link>

              <feather-icon
                  :id="`invoice-row-${data.item.id}-preview-icon`"
                  icon="TrashIcon"
                  size="16"
                  class="cursor-pointer ml-1 text-red"
                  @click="deleteDocumentTypes(data.item.id)"
              />
              <b-tooltip
                  title="Eliminar Documento"
                  :target="`invoice-row-${data.item.id}-preview-icon`"
              />
            </template>
          </b-table>

          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">Mostrando {{ pageLength }} de {{ totalRecords }} tipos de documentos</span>
              </b-col>

              <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                    :value="1"
                    :total-rows="totalRecords"
                    :per-page="pageLength"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="changePage"
                >
                  <template #prev-text>
                    <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {BRow, BCol, BTable, BCard, BButton, BTooltip, BPagination, BOverlay, BBadge} from 'bootstrap-vue'
import vSelect from "vue-select"
import {mapState} from "vuex"
import Swal from "sweetalert2"
import {GEI_AUXILIAR_DOCUMENTTYPES_CREATE} from "@/router/web/constants"
import helpers from "@/resources/helpers/helpers"
import SearchView from "@/views/gei/auxiliars_documentTypes/list/components/searchView.vue"
import helper from "@/resources/helpers/helpers"
import ExcelJS from "exceljs"

export default {
	name: "ListView",
  components: {
    BRow,
    BCol,
    BTable,
    BCard,
    BButton,
    BTooltip,
    BPagination,
    BOverlay,
    SearchView,
    vSelect,

  },
	data() {
		return {
			page: 1,
			pageLength: 10,
			totalRecords: 10,
      columns: [
        {key: 'type', label: 'Tipo de documento', sortable: false},
        {key: 'description', label: 'Descripción', sortable: false},
        {key: 'to_keeper_contract', label: 'Disponible en contrato mantenedor', sortable: false},
        {key: 'to_manual_project_contract', label: 'Disponible en documentación, proyectos y manuales', sortable: false},
        {key: 'to_maintenance', label: 'Disponible en mantenimientos', sortable: false},
        {key: 'actions', label: 'Acciones', sortable: false},
      ],
			showLoading: false,
            helpers
		}
	},
	computed: {
		...mapState('auxiliariesDocumentTypes', ['document_types', 'search']),
	},
	created() {
		this.getDocumentTypes()
	},
	methods: {
		can(permission) {
			return this.$store.getters.can(permission)
		},
		formatDate(date) {
			const dateFormated = new Date(date)

			return dateFormated.toLocaleDateString("es-ES")
		},
    getDocumentTypes() {
			this.showLoading = true

      this.$store.dispatch('auxiliariesDocumentTypes/searchDocumentTypes', {
				per_page: this.pageLength,
				page: this.page,
        filter: this.search,
			})
				.then(response => {
					this.showLoading = false
          this.totalRecords = response.total_records

				})
				.catch(error => {
					this.showLoading = false
					console.log(error)
				})
		},
    exportToExcel() {
      this.showLoading = true

      this.$store.dispatch('auxiliariesDocumentTypes/searchDocumentTypes', {
        per_page: this.totalRecords,
        page: 1,
        filter: this.search,
      })
          .then(response => {
            const allDocumentTypes = Array.isArray(response.data) ? response.data : []

            const workbook = new ExcelJS.Workbook()
            const worksheet = workbook.addWorksheet('Tipos de Documentos')

            worksheet.columns = [
              { header: 'Tipo de documento', key: 'type', width: 30 },
              { header: 'Descripción', key: 'description', width: 30 },
              { header: 'Disponible en contrato mantenedor', key: 'to_keeper_contract', width: 35 },
              { header: 'Disponible en documentación, proyectos y manuales', key: 'to_manual_project_contract', width: 35 },
              { header: 'Disponible en mantenimientos', key: 'to_maintenance', width: 30 },
            ]

            allDocumentTypes.forEach(item => {
              worksheet.addRow({
                type: item.type,
                description: item.description,
                to_keeper_contract: item.to_keeper_contract ? 'Sí' : 'No',
                to_manual_project_contract: item.to_manual_project_contract ? 'Sí' : 'No',
                to_maintenance: item.to_maintenance ? 'Sí' : 'No',
              })
            })

            worksheet.columns.forEach(column => {
              column.alignment = { vertical: 'middle', horizontal: 'left' }
            })

            workbook.xlsx.writeBuffer().then(buffer => {
              const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
              const link = document.createElement('a')
              link.href = URL.createObjectURL(blob)
              link.download = 'TiposDeDocumentos.xlsx'
              link.click()
              URL.revokeObjectURL(link.href)

              this.showLoading = false
            })
          })
          .catch(error => {
            console.error('Error al obtener los tipos de documento:', error)
            this.showLoading = false
          })
    },

    deleteDocumentTypes(id) {
			Swal.fire({
                title: "Estás seguro que quieres eliminar este tipo de documento?",
                text: "Una vez borrada no se podra recuperar!",
                icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#34c38f",
				cancelButtonColor: "#f46a6a",
				confirmButtonText: "Sí, borrar!",
				cancelButtonText: "Cancelar",
			}).then(result => {
				if (result.value) {
					this.$store.dispatch('auxiliariesDocumentTypes/deleteDocumentTypes', {id: id})
						.then(response => {
							this.showLoading = false
                            helper.showToast('Tipo de documento eliminado correctamente!', 'CheckIcon', 'success')
							this.getDocumentTypes()
						})
						.catch(error => {
							this.showLoading = false
                            helper.showToast('Error al eliminar el tipo de documento', 'AlertOctagonIcon', 'danger')
                            console.log(error)
						})
				}
			})
		},
    changePage(page) {
      this.page = page
      this.getDocumentTypes()
    },
    changeLength(length) {
      this.length = length
      this.getDocumentTypes()
    },
    searchUser() {
			this.getDocumentTypes()
		},
		goToCreate(){
			this.$router.push(GEI_AUXILIAR_DOCUMENTTYPES_CREATE)
		}
	}
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>